import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => ({
  formContent: {
    marginTop: '32px',
    backgroundColor: theme.palette.common.white,
    border: '0px 1px 4px #64748b',
    borderRadius: '8px',
    padding: '16px 0px 32px 0px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },
  searchFilterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '16px 0px 24px',
    height: '100%',
    border: 'none',
  },
  stateTable: {
    backgroundColor: `${theme?.palette?.common?.white}`,
  },
  btn: {
    flexWrap: 'wrap',
    alignItems: 'center',
    flexDirection: 'row',
  },
  popupData: {
    '& .MuiDialogContent-root': {
      textAlign: 'center',
      marginTop: 32,
      marginBottom: 32,
    },
  },
  searchWrap: {
    width: '100%',
    marginBottom: '10px',
    '& .MuiSvgIcon-root': { color: theme?.palette?.grey[450] },
    '& .MuiInputBase-root': { borderRadius: '5px' },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme?.palette?.grey[100],
    },
  },
  disclaimerStyle: {
    fontSize: '0.875rem',
    color: '#6c757d',
    marginTop: '-12px',
    marginBottom: '-22px',
  },
  intercardTable: {
    paddingTop: 32,
  },
  intercardAccordion: {
    border: `1px solid ${theme.palette.grey[900]}`,
    borderRadius: '8px',
    padding: '24px 56px 18px',
    '& .MuiTypography-h3': {
      lineHeight: '24px',
    },
    '& .MuiGrid2-container': {
      padding: '0',
      marginBottom: '16px',
      '& .MuiGrid2-root': {
        padding: '0',
      },
    },
  },
}));

export default useStyles;
